import script from "./verify-otp.vue?vue&type=script&setup=true&lang=js"
export * from "./verify-otp.vue?vue&type=script&setup=true&lang=js"

import "./verify-otp.vue?vue&type=style&index=0&id=431bbff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-431bbff6"]])

export default __exports__